import {
  Box,
  Button,
  Dialog as MuiDialog,
  Stack,
  Typography,
} from '@mui/material';
import {
  ActionsSx,
  CancelButtonSx,
  ConfirmButtonSx,
  ContentSx,
  InfoIconSx,
  TitleSx,
} from '../ConfirmationDialog/ConfirmDialogProps';
import DialogTitle from '../DialogTitle/DialogTitle';
import DialogContent from '../DialogContent/DialogContent';
import DialogActions from '../DialogActions/DialogActions';
import InfoIcon from '../../assets/icons/Info';
import { DISCARD_CONFIRMATION_MESSAGE, PaperSx } from './DialogProps';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DiscardConfirmationDialog = ({ open, onConfirm, onCancel }: Props) => (
  <MuiDialog
    open={open}
    onClose={onCancel}
    slotProps={{ paper: { sx: PaperSx } }}
  >
    <DialogTitle>
      <Stack flexDirection={'column'} alignItems={'center'}>
        <InfoIcon sx={InfoIconSx('error')} />
        <Typography sx={TitleSx} textAlign={'center'}>
          Discard changes
        </Typography>
      </Stack>
    </DialogTitle>
    <DialogContent>
      <Typography sx={ContentSx} textAlign={'center'}>
        {DISCARD_CONFIRMATION_MESSAGE}
      </Typography>
    </DialogContent>
    <Box />
    <DialogActions sx={ActionsSx}>
      <Button variant="outlined" onClick={onCancel} sx={CancelButtonSx}>
        No
      </Button>
      <Button onClick={onConfirm} sx={ConfirmButtonSx('error')}>
        Yes
      </Button>
    </DialogActions>
  </MuiDialog>
);

export default DiscardConfirmationDialog;
